import { useTranslation } from 'react-i18next'
import { useScanContainer } from './ScanContainer.hooks'
import {
  AtlasH1,
  AtlasH2,
  Filler,
  Icons,
  PageContentAtom
} from '@justomx/atlas-components'
import { MenuWrapperOrganism } from 'components/organisms/MenuWrapper.organism'
import LoaderAtom from 'components/atoms/Loader.atom'

export const ScanContainerPage = () => {
  const { isLoading } = useScanContainer()
  const { t } = useTranslation('global')

  if (isLoading) {
    return (
      <LoaderAtom>{t('loader.message')}</LoaderAtom>
    )
  }

  return (
    <>
      <MenuWrapperOrganism
        title="Corregir inventario"
        secondaryAction={Icons.IcKeyboardIcon}
        onSecondaryAction={() => {}}
      />
      <PageContentAtom $centered>
        <Filler flexGrow={1} />
        <AtlasH2 style={{ color: '#c2c2c2' }}>Escanea</AtlasH2>
        <AtlasH1 style={{ textAlign: 'center' }}>Tarima</AtlasH1>
        <Filler />
      </PageContentAtom>
    </>
  )
}
